/** Conta a receber elegível para emissão de NFSe a partir do recebimento (Focus). */
export type ReceivableNfseLike = {
  status?: string | null;
  patient_id?: string | null;
  clinic_patients?: unknown;
};

export function canEmitNfseForReceivable(acc: ReceivableNfseLike): boolean {
  return (acc.status === 'paid' || acc.status === 'card_authorized')
    && Boolean(acc.patient_id || acc.clinic_patients);
}
